import { HttpClient } from "./HttpClient";
import * as endPoints from "constants/endPoints"

export class RegisterRequestService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async RegisterRequestItem(bodyData) {
        const { data } = await this.http.postBody(endPoints.REGISTER_REQUEST, bodyData)
        return data
    }

    async RegisterRequestItemHome(bodyData) {
        const { data } = await this.http.postBody(endPoints.REGISTER_REQUEST_HOME, bodyData)
        return data
    }
}

export class DeparmentsService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getDepartmentsItems() {
        const { data } = await this.http.post(endPoints.GET_DEPARTMENTS)
        return data
    }
}

export class EntitiesService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getEntitiesItems() {
        const { data } = await this.http.post(endPoints.GET_ENTITIES)
        return data
    }
}

export class ModalitiesService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getModalitiesItems() {
        const { data } = await this.http.post(endPoints.GET_MODALITIES)
        return data
    }
}

export class OperatorsService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getOperatorItems() {
        const { data } = await this.http.post(endPoints.GET_OPERATORS)
        return data
    }
}

export class DocumentTypeService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getDocumentTypeItems(idCat) {
        const { data } = await this.http.post(endPoints.GET_DOCUMENT_TYPES)
        return data
    }
}

export class PlanService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getPlanesItems() {
        const { data } = await this.http.post(endPoints.GET_PLANS)
        return data
    }

    async getPlanesById(idPlan) {
        const { data } = await this.http.post(`${endPoints.GET_PLAN_BY_ID}?fi_plan=${idPlan}`)
        return data
    }
}

export class BankService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getBanksItems(idBank) {
        const { data } = await this.http.post(`${endPoints.GET_BANKS_BY_ID}?fi_banco=${idBank}`)
        return data
    }
}

export class ConfigService {
    constructor(http = HttpClient) {
        this.http = http
    }

    async getConfigItems(idBank) {
        const { data } = await this.http.post(`${endPoints.GET_CONFIG}?fi_banco=${idBank}`)
        return data
    }

    async getTerms5Html(urlTerms5) {
        const { bodyHtml } = await this.http.getHTML(urlTerms5)
        return bodyHtml
    }
}
